// Copyright (c) 2016 Deere & Company

import openPipPrograms from './open-pip-programs';

/* eslint-disable sorting/sort-object-props */

export default {
    childRoutes: [
        openPipPrograms
    ]
};

/* eslint-enable sorting/sort-object-props */



// WEBPACK FOOTER //
// ./src/routes/pips/reports/index.js